import { useEffect } from 'react'
import { useLocation } from 'react-router'

export const NotFound = () => {
  const location = useLocation()

  useEffect(() => {
    console.error('404 Error: User attempted to access non-existent route:', location.pathname)
  }, [location.pathname])

  return (
    <div className="flex min-h-screen items-center justify-center bg-background">
      <div className="text-center">
        <h1 className="mb-4 font-bold text-4xl">404</h1>
        <p className="mb-4 text-muted-foreground text-xl">Oops! Page not found</p>
        <a className="text-primary underline hover:text-primary/80" href="/">
          Return to Home
        </a>
      </div>
    </div>
  )
}
